<template>
  <card :overflow-off="false" :rounded="rounded" :class="[baseCss, 'inline-block', disabled ? ['opacity-50', 'pointer-events-none'] : null]" :data-color-palette="name" :elevation="elevation" v-if="colors.length">
    <card-text padding-off>
      <radio-group :name="name" :vertical="false" v-model="color" :icon-checked="iconChecked" :icon-blank="iconBlank" :icon-size="iconSize" :icon-provider="iconProvider">
        <radio :value="color.color" v-for="(color, index) in colors" :key="index" :title="color.hint" :data-color="color.color" />
      </radio-group>
    </card-text>
    <reactive-style v-for="(color, index) in colors" :key="index">
    .{{ baseCss }}[data-color-palette="{{ name }}"] [data-color="{{ color.color }}"] .bcq-icon
    {
      color: {{ color.color }};
    }
    </reactive-style>
    <reactive-style>
    .{{ baseCss }}[data-color-palette="{{ name }}"] ul
    {
      display: grid;
      grid-template-columns: repeat({{ cols }}, 1fr)
    }
    </reactive-style>
  </card>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'ColorPalette',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('color-palette', [])
    }
  },
  model: {
    prop: 'defaultColor',
    event: 'input'
  },
  props: {
    rounded: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    colors: {
      type: Array,
      default () {
        return []
      }
    },
    defaultColor: {
      type: String
    },
    cols: {
      type: Number,
      default: 6
    },
    iconChecked: {
      type: String,
      default: 'checkbox-blank-circle'
    },
    iconBlank: {
      type: String,
      default: 'checkbox-blank-circle-outline'
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    iconSize: {
      type: Number,
      default: 1.5
    },
    elevation: {
      type: String,
      default: 'none',
      validator: value => {
        return ['sm', 'md', 'lg', 'xl', '2xl', 'inner', 'none'].includes(value)
      }
    }
  },
  computed: {
    color: {
      get () {
        return this.defaultColor
      },
      set (color) {
        this.$emit('input', color)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/color-palette/color-palette.vue